/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import AllProducts from './AllProducts';

const CategoryPage = () => {
  const { category } = useParams();

  return <AllProducts category={category} />;
};

export default CategoryPage;